"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M21.914 3.172c1.1 0 2.004.857 2.08 1.939l.006.148v13.482c0 1.1-.856 2.005-1.937 2.081l-.149.006H2.086a2.09 2.09 0 0 1-2.08-1.938L0 18.741V5.26a2.09 2.09 0 0 1 1.937-2.081l.149-.006h19.828Zm0 1H2.086c-.56 0-1.02.425-1.08.97L1 5.258V18.74c0 .56.424 1.021.968 1.08l.118.006h19.828c.56 0 1.02-.424 1.08-.967L23 18.74V5.26c0-.56-.424-1.021-.968-1.08l-.118-.007ZM10.017 12.69c1.1 0 2.004.856 2.08 1.937l.006.149v1.587a.5.5 0 0 1-.992.09l-.008-.09v-1.587c0-.56-.424-1.02-.968-1.08l-.118-.006H6.052c-.559 0-1.021.424-1.08.968l-.007.118v1.587a.5.5 0 0 1-.992.09l-.008-.09v-1.587c0-1.1.856-2.005 1.938-2.081l.15-.005h3.964Zm9.517 2.38a.5.5 0 0 1 .09.991l-.09.009h-4.759a.5.5 0 0 1-.09-.992l.09-.008h4.76Zm0-3.966a.5.5 0 0 1 .09.992l-.09.008h-4.759a.5.5 0 0 1-.09-.992l.09-.008h4.76ZM6.28 7.865a2.486 2.486 0 0 1 3.51 0c.47.47.729 1.092.729 1.755 0 .665-.26 1.288-.728 1.757a2.473 2.473 0 0 1-1.755.725 2.476 2.476 0 0 1-1.756-.726 2.485 2.485 0 0 1 0-3.51Zm1.755.273a1.485 1.485 0 0 0-1.048 2.531 1.484 1.484 0 0 0 2.097-2.097 1.48 1.48 0 0 0-1.05-.434Zm11.5-1a.5.5 0 0 1 .09.992l-.09.008h-4.759a.5.5 0 0 1-.09-.992l.09-.008h4.76Z",
    clipRule: "evenodd"
  })]
});